import React from 'react'
import './App.css';
import './index.css';
import {Footer, Blog, Possibility, Features, WhatRBCSW, Header} from './containers';
import {CTA, Brand, Navbar} from './components';

const App = () => {
  return (
    // <div><h1>RebeccaSoftware.Space</h1>
    <div className='App'>
      <div className='gradian__bg'>
        <Navbar />
        <Header />
      </div>
      <Brand />
      <WhatRBCSW />
      <Features />
      <Possibility />
      <CTA />
      <Blog />
      <Footer />
    </div>
    // </div>
  )
}

export default App